module.exports = __webpack_public_path__ + "media/public/img/google-favicon-01-85735b7e39874413a72c1601d7f4d833.svg";